export interface ChannelSeriesEntry {
  name: string;
  data: ArrayLike<number>;
  sampleRate?: number;
}

export function findChannelSeries(
  channelSeries: ChannelSeriesEntry[],
  channelLabel: string | null | undefined,
): ChannelSeriesEntry | undefined {
  if (!channelLabel) {
    return undefined;
  }

  return (
    channelSeries.find((series) => series.name === channelLabel) ??
    channelSeries.find((series) => channelLabel.startsWith(series.name))
  );
}

export function sliceChannelDataForViewerWindow(params: {
  series: ChannelSeriesEntry;
  currentTimeMs: number;
  timeWindowMs: number;
  minSampleCount?: number;
  defaultSamplingRate: number;
}): { data: number[]; sampleRate: number } {
  const {
    series,
    currentTimeMs,
    timeWindowMs,
    minSampleCount = 1,
    defaultSamplingRate,
  } = params;

  const sampleRate = series.sampleRate || defaultSamplingRate;
  const startSample = Math.max(
    0,
    Math.floor((currentTimeMs / 1000) * sampleRate),
  );
  const sampleCount = Math.max(
    minSampleCount,
    Math.ceil((timeWindowMs / 1000) * sampleRate),
  );
  const endSample = Math.min(series.data.length, startSample + sampleCount);
  const data = Array.from(
    Array.prototype.slice.call(series.data, startSample, endSample) as number[],
    (value) => Number(value),
  ).filter(Number.isFinite);

  return { data, sampleRate };
}
